export default "__VITE_ASSET__Cl9F8Pc7__"